import { render, staticRenderFns } from "./passAnalysisCard.vue?vue&type=template&id=3f07c966&scoped=true&"
import script from "./passAnalysisCard.vue?vue&type=script&lang=js&"
export * from "./passAnalysisCard.vue?vue&type=script&lang=js&"
import style0 from "./passAnalysisCard.vue?vue&type=style&index=0&id=3f07c966&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f07c966",
  null
  
)

export default component.exports